import React, { useCallback, useEffect, useRef, useState } from 'react';
import jsQR, { QRCode } from 'jsqr';
import Box from '@mui/material/Box';
import SFBottomNavigation from '@/component/common/sf-bottom-navigator';
import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';
import { SFPalette } from '@/lib/color';
import { fontWeight } from '@/theme';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom';
import { get_code, qr_camera_call } from '@/component/linkMobile/qrCam';
import { toast } from 'react-toastify';
const CornerMarker = ({
  position,
  color = SFPalette.shuffleColor,
}: {
  position: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';
  color?: string;
}) => {
  const [vertical, horizontal] = position.split('-');

  const sxProps = {
    position: 'absolute',
    [vertical]: 0,
    [horizontal]: 0,
    '&::before': {
      content: '""',
      position: 'absolute',
      backgroundColor: color,
      width: '32px',
      height: '4px',
      [vertical]: 0,
      [horizontal]: 0,
      borderRadius:
        vertical === 'top'
          ? horizontal === 'left'
            ? '32px 0 0 0'
            : '0 32px 0 0'
          : horizontal === 'left'
          ? '0 0 0 32px'
          : '0 0 32px 0',
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      backgroundColor: color,
      height: '32px',
      width: '4px',
      [vertical]: 0,
      [horizontal]: 0,
      borderRadius:
        vertical === 'top'
          ? horizontal === 'left'
            ? '32px 0 0 0'
            : '0 32px 0 0'
          : horizontal === 'left'
          ? '0 0 0 32px'
          : '0 0 32px 0',
    },
  };

  return <Box sx={sxProps} />;
};

function QRScanPage() {
  const navigate = useNavigate();
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const [windowHeight, setWindowHeight] = useState<number>(window.innerHeight);

  window.appInterFace = (val: any) => {
    alert(val);
    navigate(-2);
  };

  useEffect(() => {
    let param = {
      action: 'qrcamera',
      callback: 'appInterFace',
    };
    if (window.webkit.messageHandlers.cordova_iab) {
      // cordova_iab 잇는지 확인
      window.webkit.messageHandlers.cordova_iab.postMessage(JSON.stringify(param));
    } else {
      console.log(`webkit null`);
      toast.error('카메라 기능 일시 오류');
      navigate(-1);
    }
    return () => {};
  }, []);

  useEffect(() => {
    setWindowHeight(window.innerHeight);
    const handleResize = () => setWindowHeight(window.innerHeight);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const camTemp = () => {
    console.log(`camTemp`);
  };
  /**
   * @todo QR 결제 플로우를 별도로 만들어야 합니다.
   */
  const tick = () => {
    if (videoRef.current && canvasRef.current) {
      if (videoRef.current.readyState === videoRef.current.HAVE_ENOUGH_DATA) {
        const video = videoRef.current;
        const canvas = canvasRef.current;
        canvas.height = video.videoHeight;
        canvas.width = video.videoWidth;

        const ctx = canvas.getContext('2d');

        if (!ctx) {
          console.error('Unable to get 2D context from canvas');
          return;
        }

        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const code = jsQR(imageData.data, imageData.width, imageData.height, {
          inversionAttempts: 'dontInvert',
        });

        if (code?.data) {
          // window.location.href = code.data;
          alert('QR 코드를 찾았습니다: ' + code.data);
          console.log('$$ code', code);
          get_code(code);
        }
      }

      requestAnimationFrame(tick);
    }
  };

  useEffect(() => {
    // console.log(`aaaaaaaaaaaaaaaaaaaaaaaa`);
    // qr_camera_call();
    // 카메라 웹버전
    // if (videoRef.current && canvasRef.current) {
    //   if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
    //     navigator.mediaDevices
    //       .getUserMedia({ video: { facingMode: 'environment' } })
    //       .then((stream) => {
    //         if (videoRef.current) {
    //           qr_camera_call();
    //           videoRef.current.srcObject = stream;
    //           videoRef.current.setAttribute('playsinline', 'true'); // required to tell iOS safari we don't want fullscreen
    //           videoRef.current.play();
    //           requestAnimationFrame(tick);
    //         }
    //       })
    //       .catch((error) => {
    //         toast.error(error);
    //         alert('카메라에 접근할 수 없습니다.');
    //         // alert(error)
    //         navigate(-1);
    //       });
    //   } else {
    //     alert('카메라에 접근할 수 없습니다. 이 기능은 HTTPS 연결을 통해 제공되어야 합니다.');
    //   }
    // }
  }, []);

  return (
    <>
      <Stack
        sx={{
          width: '100vw',
          height: `${windowHeight}px`,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          bgcolor: '#3D3D3D',
          position: 'relative',
          maxHeight: '100vh',
        }}
      >
        {/* qr화면
        <video ref={videoRef} style={{ display: 'none' }}></video> */}
        {/* <Stack flex={1} justifyContent="center" position="relative">
          <canvas ref={canvasRef} style={{ width: '100%' }}></canvas>
          <Box
            sx={{
              position: 'absolute',
              width: '100%',
              height: '100%',
              background: 'rgba(0, 0, 0, 0.5)',
            }}
          >
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                height: '80vmin',
                width: '80vmin',
                minWidth: '300px',
                minHeight: '300px',
                maxWidth: '500px',
                maxHeight: '500px',
                transform: 'translate(-50%, -50%)',
                background: 'transparent',
                // border: "1px solid rgba(255,255,255,0.5)",
                borderRadius: 4,
                boxShadow: '0 0 0 2000px rgba(0, 0, 0, 0.5)',
              }}
            >
              <CornerMarker position="top-left" />
              <CornerMarker position="top-right" />
              <CornerMarker position="bottom-left" />
              <CornerMarker position="bottom-right" />
            </Box>
          </Box>
          <Box position="relative" top={48}>
            <Typography variant="subtitle1" color="white" fontWeight={fontWeight.Bold} textAlign="center">
              카메라 종료
            </Typography>
          </Box>
        </Stack> */}
        {/* <Container
          maxWidth="sm"
          sx={{
            bgcolor: 'white',
            position: 'sticky',
            bottom: 0,
          }}
        >
          <SFBottomNavigation selectedLabel="스캔" />
        </Container> */}
      </Stack>
    </>
  );
}

export default QRScanPage;
